import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})
export interface FormContext {
  customizationFields: CustomizationField[]
}

export const BasicDetailsSchema = ({ customizationFields }: FormContext) => {
  return z.object({
    documentType: z
      .string()
      .optional()
      .refine(
        (documentType) =>
          isMandatory('documentType', 'expense', customizationFields) ? !!documentType : true,
        defaultRequiredMessage()
      ),
  })
}
export type BasicDetailsSchema = z.infer<ReturnType<typeof BasicDetailsSchema>>
